import type {Moment} from 'moment-timezone';

import type {InputMaybe, MonthlyInvoicingOptions} from '@famly/vet_api-types';

export const MonthlyInvoicingDue = {
    EXACT_DAY_OF_MONTH: 'EXACT_DAY_OF_MONTH',
    FIRST_WORKING_DAY_OF_MONTH: 'FIRST_WORKING_DAY_OF_MONTH',
    LAST_WORKING_DAY_OF_MONTH: 'LAST_WORKING_DAY_OF_MONTH',
    RELATIVE_TO_BILLING_DATE: 'RELATIVE_TO_BILLING_DATE',
} as const;

export type MonthlyInvoicingDueType = typeof MonthlyInvoicingDue[keyof typeof MonthlyInvoicingDue];

export const WeeklyInvoicingDue = {
    EXACT_DAY_OF_WEEK: 'EXACT_DAY_OF_WEEK',
    RELATIVE_TO_BILLING_DATE: 'RELATIVE_TO_BILLING_DATE',
} as const;

export type WeeklyInvoicingDueType = typeof WeeklyInvoicingDue[keyof typeof WeeklyInvoicingDue];

export interface MonthlyState {
    isEnabled: boolean;
    billingDate: InputMaybe<MonthlyInvoicingOptions>;
    billingExactDay: InputMaybe<string>;
    invoicingDue: InputMaybe<string>;
    invoicingDueExactDay: InputMaybe<string>;
    invoicingDueDaysAfterBilling: InputMaybe<string>;
}

export interface BiWeeklyState {
    isEnabled: boolean;
    billingDate: InputMaybe<Moment>;
    invoicingDue: InputMaybe<string>;
    invoicingDueDaysAfterBilling: InputMaybe<string>;
}

export interface WeeklyState {
    isEnabled: boolean;
    billingDate: InputMaybe<string>;
    invoicingDue: InputMaybe<string>;
    invoicingDueDaysAfterBilling: InputMaybe<string>;
}
